import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Site set up",
  "description": "",
  "published": "2006-04-21T00:00:00.000Z",
  "redirect_from": ["/blog/site-set-up/swizec/430"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`[`}{`size=13]It would seem that finally the basics of this website have been succesfully set up with `}{`[`}{`[`}<a parentName="p" {...{
        "href": "http://chlorineboards.swizec.com%7CChlorine"
      }}>{`http://chlorineboards.swizec.com|Chlorine`}</a>{` Board's]] fancy self installer. The reason it took long was the bugs ... happens you know, bugs are natural.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      